export const LANGUAGES = [
  { val: 'tr', name: 'Türkçe' },
  { val: 'ru', name: 'Русский' },
  { val: 'en', name: 'English' },
  { val: 'kk', name: 'Казакша' },
  { val: 'ky', name: 'Кыргызча' },
  { val: 'ka', name: 'ქართული' },
  { val: 'uz', name: 'O‘zbekcha' },
  { val: 'iq', name: 'Iraq' },
  { val: 'az', name: 'Azerbaijan' },
];

export const COUNTRIES = [
  // {
  //   devDomain: 'localhost',
  //   val: 'tr',
  //   engName: 'Turkey',
  //   id: 3,
  //   name: 'Türkiye',
  //   domain: ['flp-v2.vercel.app'],
  //   additionalLink: 'https://flp-v2.vercel.app/',
  //   googleAnalytics: 'GTM-KP3KNX',
  //   languages: [
  //     { val: 'tr', name: 'Türkçe' },
  //     { val: 'en', name: 'English' },
  //     { val: 'ru', name: 'Русский' },
  //     { val: 'kk', name: 'Казакша' },
  //     { val: 'ky', name: 'Кыргызча' },
  //     { val: 'ka', name: 'ქართული' },
  //     { val: 'uz', name: 'O‘zbekcha' },
  //   ],
  // },
    {
      devDomain: 'tr.flp',
      val: 'tr',
      engName: 'Turkey',
      id: 3,
      name: 'Türkiye',
      domain: ['tr.teamflptr.com', 'www.flptr.com', 'flptr.com'],
      additionalLink: 'https://www.flptr.com/',
      googleAnalytics: 'GTM-KP3KNX',
      languages: [
        { val: 'tr', name: 'Türkçe' },
        { val: 'en', name: 'English' },
      ],
    },
    {
    devDomain: 'uz.flp',
    val: 'uz',
    engName: 'Uzbekistan',
    id: 7,
    name: 'Uzbekistan',
    domain: ['uz.teamflptr.com', 'www.flpuz.com', 'flpuz.com'],
    additionalLink: 'https://www.flpuz.com/',
    googleAnalytics: 'GTM-WJMNPKC6',
    languages: [
      { val: 'uz', name: 'O‘zbekcha' },
      { val: 'ru', name: 'Русский' },
      { val: 'en', name: 'English' },
    ],
  },
  {
    devDomain: 'ir.flp',
    val: 'iq',
    engName: 'Iraq',
    id: 6,
    name: 'اَلْعِرَاق‎',
    domain: ['ir.teamflptr.com', 'www.flpirq.com', 'flpirq.com', 'www.flpiraq.com', 'flpiraq.com'],
    additionalLink: 'https://www.flpirq.com/',
    googleAnalytics: 'GTM-5SHG5M7',
    languages: [
      { val: 'en', name: 'English' },
    ],
  },
  {
    devDomain: 'ge.flp',
    val: 'ge',
    engName: 'Goergia',
    id: 5,
    name: 'საქართველო',
    domain: ['ge.teamflptr.com', 'flp.ge', 'www.flp.ge'],
    additionalLink: 'https://www.flp.ge/',
    googleAnalytics: 'GTM-N3TBR3G',
    languages: [
      { val: 'ka', name: 'ქართული' },
      { val: 'ru', name: 'Русский' },
      { val: 'en', name: 'English' },
    ],
  },
  {
    devDomain: 'az.flp',
    val: 'az',
    engName: 'Azerbaijan',
    id: 4,
    name: 'Azərbaycan',
    domain: ['az.teamflptr.com', 'flpaze.com', 'www.flpaze.com'],
    additionalLink: 'https://www.flpaze.com/',
    googleAnalytics: 'GTM-T2S558Z',
    languages: [
      { val: 'az', name: 'Azərbaycan' },
      { val: 'ru', name: 'Русский' },
      { val: 'en', name: 'English' },
    ],
  },
  {
    devDomain: 'kg.flp',
    val: 'kg',
    engName: 'Kyrgyzstan',
    id: 1,
    name: 'Кыргызстан',
    domain: ['kg.teamflptr.com', 'www.flpkgz.com', 'flpkgz.com'],
    additionalLink: 'https://www.flpkgz.com/',
    googleAnalytics: 'GTM-56GCJ6Z',
    languages: [
      { val: 'ky', name: 'Кыргызча' },
      { val: 'ru', name: 'Русский' },
      { val: 'en', name: 'English' },
    ],
  },
  {
    devDomain: 'kz.flp',
    val: 'kz',
    engName: 'Kazakhstan',
    id: 2,
    name: 'Қазақстан',
    domain: ['kz.teamflptr.com', 'www.flpkaz.com', 'flpkaz.com'],
    additionalLink: 'https://www.flpkaz.com/',
    googleAnalytics: 'GTM-NK6BHTF',
    languages: [
      { val: 'kk', name: 'Казакша' },
      { val: 'ru', name: 'Русский' },
      { val: 'en', name: 'English' },
    ],
  },
];
export type Location = string;


export function getCountryInfo(location: Location) {
  return COUNTRIES.find(country => country.val === location);
}

export function getCountryByDomain(hostname?: string): typeof COUNTRIES[number] | undefined {
  if (!hostname && typeof window === 'undefined') {
    return undefined;
  }
  
  const currentDomain = hostname || (typeof window !== 'undefined' ? window.location.hostname : '');
  return COUNTRIES.find(country => 
    country.domain.includes(currentDomain) || country.devDomain === currentDomain
  );
}

export function getCurrentLocationAndLanguage(hostname?: string) {
  let country;

  if (process.env.NODE_ENV === 'development') {
    const devDomain = hostname || 'localhost';
    country = COUNTRIES.find((c) => c.devDomain === devDomain);
  }

  if (!country) {
    const currentDomain = hostname || (typeof window !== 'undefined' ? window.location.hostname : '');
    country = COUNTRIES.find((c) => c.domain.includes(currentDomain) || c.devDomain === currentDomain);
  }

  if (country) {
    return {
      location: country.val,
      language: country.languages[0].val,
    };
  }

  const defaultCountry = COUNTRIES[0];
  return {
    location: defaultCountry.val,
    language: defaultCountry.languages[0].val,
  };
}


export type LocationKey = 'tr' | 'az' | 'kg' | 'ge' | 'iq' | 'kz' | 'uz';
export type LanguageKey = 'en' | 'tr' | 'ru' | 'az' | 'kk' | 'ka' | 'ky' | 'iq' | 'uz';
